import { createAction, createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const askRequest = createRequest(constants.ask);
export const askSuccess = createSuccess(constants.ask);
export const askFailure = createFailure(constants.ask);

export const feedbackRequest = createRequest(constants.feedback);
export const feedbackSuccess = createSuccess(constants.feedback);
export const feedbackFailure = createFailure(constants.feedback);

export const resetAsk = createAction(constants.reset);
export const setCategory = createAction(constants.setCategory);
